module.exports = __webpack_public_path__ + "static/media/success.f1fc60ee.svg";